module.exports = __webpack_public_path__ + "img/todos.62b369ce.png";